import './Charts.css';
import EnrollmentByAge from './EnrollmentByAge';
import TotalPremiumByPlanType from './TotalPremiumByPlanType';
import { getText } from '../../i18n';

function Charts() {
    return (
        <>
            <div
                className="card d-inline-block shadow-sm border-light me-4 mb-4"
                style={{ width: 450 }}
            >
                <div className="card-body">
                    {/* Customization button disabled on dashboard */}
                    {/*<div className="ellipsis d-flex align-items-center justify-content-center float-end">
                        <i className="bi bi-three-dots"></i>
                    </div>*/}
                    <p className="chart-title card-title ms-4">
                        {getText('msg_3738ce3f2279')}
                    </p>
                    <p className="chart-subtitle mb-4 ms-4">{getText('msg_3703cd216881')}</p>
                    <EnrollmentByAge />
                </div>
            </div>
            <div
                className="card d-inline-block shadow-sm border-light"
                style={{ width: 450 }}
            >
                <div className="card-body">
                    {/* Customization button disabled on dashboard */}
                    {/*<div className="ellipsis d-flex align-items-center justify-content-center float-end">
                        <i className="bi bi-three-dots"></i>
                    </div>*/}
                    <p className="chart-title card-title ms-4">
                        {getText('msg_c4d8097226a7')}
                    </p>
                    <p className="chart-subtitle mb-4 ms-4">{getText('msg_3703cd216881')}</p>
                    <TotalPremiumByPlanType />
                </div>
            </div>
        </>
    );
}

export default Charts;
